import React, { useEffect } from 'react'
import { MetricTimeUnit, MeasureType } from 'enums'
import { createMetric } from 'utils/runSearchUtil'
import { useAppDispatch } from 'app/hooks'
import { getInsightContentData } from 'features/insightContent/asyncThunks'
import { getMetricSeries } from 'utils/measureTypeUtil'
import { InsightContentSettingType } from 'components/insightContent/types'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import {
  TREND_MEASURES,
  DETAIL_SUMMARY_TOPIC_COMPARISON_MEASURES,
  DETAIL_SUMMARY_AM_TOPIC_COMPARISON_MEASURES
} from 'components/widget/TopicComparisonWidgets/share/RunSearchEffect/constants'
import { getSparklineMetricTimeUnit } from 'utils/sparklineMetricTimeUnit'

const createSearches = (detailSetting: InsightContentSettingType, isAudienceQuery?: boolean) => {
  const { filter, precision } = detailSetting
  const timeUnits = [MetricTimeUnit.ALL, getSparklineMetricTimeUnit(filter?.publishedDate)]

  const searches = detailSetting.topicInfos!.map(({ topicId }) =>
    createMetric(
      -1,
      '',
      precision!,
      [topicId!],
      filter,
      isAudienceQuery
        ? getMetricSeries(MeasureType.UNIQUE_AUTHORS)
        : TREND_MEASURES.flatMap(getMetricSeries),
      timeUnits,
      { isAudienceQuery }
    )
  )

  if (detailSetting.topicId) {
    searches.push(
      createMetric(
        -1,
        '',
        precision!,
        [detailSetting.topicId],
        filter,
        isAudienceQuery
          ? DETAIL_SUMMARY_AM_TOPIC_COMPARISON_MEASURES.flatMap(getMetricSeries)
          : DETAIL_SUMMARY_TOPIC_COMPARISON_MEASURES.flatMap(getMetricSeries),
        timeUnits,
        { isAudienceQuery }
      )
    )
  }

  return searches
}

const RunSearchEffect = ({
  detailSetting,
  children,
  isAudienceQuery
}: {
  detailSetting: InsightContentSettingType
  children: React.ReactNode
  isAudienceQuery?: boolean
}) => {
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp()

  useEffect(() => {
    const searches = createSearches(detailSetting, isAudienceQuery)

    dispatch(
      getInsightContentData({
        insightContentType: InsightContentType.TOPIC_COMPARISON,
        searches,
        timestamp: refreshTimestamp
      })
    )
  }, [dispatch, detailSetting, refreshTimestamp, isAudienceQuery])

  return <>{children}</>
}

export default RunSearchEffect
